<div class="doc-upload-spinner {{active?'active':''}}">
  <i class="fa fa-spin fa-refresh "></i>
  <!-- <img src="../../../../../../assets/images/icons/Spinner.svg" /> -->
  <div class="spinner-text">{{sanitizeText(activeText)}}</div>

</div>
